<div class="account-hero">
  <router-outlet></router-outlet>
</div>

